
export type DateHourType = {
    days: Record<string, boolean>;
    hours: Record<number, boolean>;

}

export type NotificationsDateTimeType = {
    approver?: DateHourType;
    admin?: DateHourType;
}


export type NotificationType = {
    newTaskForApprover: boolean;
    overdueRemainder: boolean;
    taskBlocked: boolean;
    appointedAsSubstitute: boolean;
    documentBlocked: boolean;
    dateTime: NotificationsDateTimeType;
    isUserAdmin?: boolean;
    isUserApprover?: boolean;
};

export const EVENT_TYPES = {
    NEW_APPROVAL_TASK: 1,
    APPOINTED_SUBSTITUTE: 6,
    TASK_BLOCKED: 2,
    DOCUMENT_BLOCKED: 7,
    EMAIL_ENABLED: 8,
    EMAIL_EVENTS: 11,
    ADMIN_EMAIL_EVENTS: 12,
};
export const DAYS_OF_THE_WEEK = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"];

export const DAYS_OF_THE_WEEK_NUMBER = {
    "sunday": 1,
    "monday": 2,
    "tuesday": 3,
    "wednesday": 4,
    "thursday": 5,
    "friday": 6,
    "saturday": 7
}

export const USER_TYPE = {
    ADMIN: "admin",
    APPROVER: "approver",
};

export type USER_TYPE_KEYS = keyof typeof USER_TYPE;

export const DAYS_HOURS = {
    DAYS:"days",
    HOURS:"hours",
}

export type DAY_TIME_KEYS = keyof typeof DAYS_HOURS;


export const SETTINGS_AVAILABLE_HOURS = [7, 9, 11, 13, 15, 17, 19];
